export const mostrarPorUM = (reg) => {
    if(reg?.multiplicador === "um") return "Por UM"
    return "Tarifa fija" 
}